module.exports = __webpack_public_path__ + "static/media/about-us.6dd23c09.jpg";